<template>
  <div class="prod">
    <div
      class="full-section full-section__main anim anim-opacity-1"
      data-section="start"
      data-anim
    >
      <div v-rellax="rellax" class="rellax">
        <img src="@/assets/img/catalogue/phantom/1.jpg" :alt="$imageAlt(1)" />
      </div>
    </div>

    <div class="grid">
      <div class="section text-wrap" data-section="title" data-anim>
        <SeoHeading class="text anim anim-scene-1" />
        <span class="text-line"></span>
      </div>

      <div class="section" data-section="2">
        <div class="col-left" data-anim>
          <img
            src="@/assets/img/catalogue/phantom/2.jpg"
            :alt="$imageAlt(2)"
            class="anim anim-scene-1"
          />
        </div>
        <div class="col-right" data-anim>
          <img
            src="@/assets/img/catalogue/phantom/3.jpg"
            :alt="$imageAlt(3)"
            class="anim anim-scene-2 anim-scene-1-mob"
          />
        </div>
      </div>

      <div class="section">
        <div class="col-right" data-anim>
          <img
            src="@/assets/img/catalogue/phantom/4.webp"
            :alt="$imageAlt(4)"
            class="anim anim-scene-1"
          />
        </div>
      </div>

      <div class="section" data-section="1">
        <div class="col-left" data-anim>
          <img
            src="@/assets/img/catalogue/phantom/5.jpg"
            :alt="$imageAlt(5)"
            class="anim anim-scene-1"
          />
        </div>
        <div class="col-right" data-anim>
          <img
            src="@/assets/img/catalogue/phantom/6.jpg"
            :alt="$imageAlt(6)"
            class="anim anim-scene-2 anim-scene-1-mob"
          />
        </div>
      </div>

      <div class="section" data-section="2">
        <div class="col-left" data-anim>
          <img
            src="@/assets/img/catalogue/phantom/7.jpg"
            :alt="$imageAlt(7)"
            class="anim anim-scene-1"
          />
        </div>
        <div class="col-right" data-anim>
          <img
            src="@/assets/img/catalogue/phantom/8.jpg"
            :alt="$imageAlt(8)"
            class="anim anim-scene-2 anim-scene-1-mob"
          />
        </div>
      </div>
    </div>

    <Form extra="kitchen_phantom" />

    <NextSection
      subtitle="следующий концепт"
      title="Edge"
      link="/catalog/edge"
      image="catalogue/phantom/next.jpg"
      imageMob="catalogue/phantom/next_mob.jpg"
    />
  </div>
</template>

<script>
import anims from '@/mixins/anims'
import rellax from '../../../mixins/rellax'
import Form from '@/components/common/Forms/Form'
import NextSection from '../../common/NextSection.vue'

export default {
  name: 'Phantom',

  components: {
    Form,
    NextSection
  },

  mixins: [anims, rellax]
}
</script>
<style lang="scss" scoped>
@import "@/styles/product_card.scss";
</style>
